import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function FeaturedContent() {
  const featured = videos.filter((v) => v.isHot).slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">
              大家都在看的精彩内容
            </p>
          </div>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {featured.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-2.5">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 flex items-center gap-1.5 flex-wrap">
                  {video.isVip && (
                    <span className="px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-semibold rounded">
                      VIP
                    </span>
                  )}
                  <span className="px-2 py-0.5 bg-background-950/70 text-foreground-950 text-xs rounded">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
                  <span className="text-xs text-white/80">{video.duration}</span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {video.type} · {video.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}